<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Warehouse Delivered Orders</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :permissions="{
            send_to_pending_shipment: 'send_to_pending_shipment',
            generate_qr_code: 'purchase_generate_qrcode',
            add_permission: 'add_new_order',
            new_shiponly: 'new_shiponly',
          }"
          :addNewOrderButton="false"
          :addNewShiponlyButton="true"
          :openAddNewShiponlyModal="openAddNewShiponlyModal"
          :openAddNewOrderModal="openAddNewOrderModal"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :addSendToIntShipmentButton="true"
          :addSendAllToIntShipmentButton="true"
          :addQrCodeGenerateButton="true"
          :openGenerateQrCodeModal="openGenerateQrCodeModal"
          :openSendToIntShipmentModal="openSendToIntShipmentModal"
          :sendAllToIntShipment="sendAllToIntShipment"
          :tableData="tableData"
          :addExportButton="true"
          :sendToExport="sendToExport"
          :resetGetResults="resetGetResults"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :resetGetResults2="resetGetResults2"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
          @branch-edit="branchEdit"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.order_id"
                :style="qrCodeValues.find(x => x[0] == r.order_id) ? 'background-color: #FFF9C4' : '' "
                class="table-tr"
              >
                <td>
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[
                      r.order_id,
                      r.full_name,
                      r.phone_number,
                      r.user_id,
                      r.theOrderID,
                      r.is_ship_only,
                      r.product_name,
                    ]"
                    v-model="qrCodeValues"
                  />
                  <!-- r.deliver_branch_name,
                      r.deliver_branch_id_fk, -->
                </td>
                <td
                  style="min-width: 130px"
                  class="hover-container"
                >
                  <view-order-users :orderData="r" />
                </td>
                <!-- <td>
                  <display-branch :data="r" />
                </td> -->
                <td><i
                    class="fa fa-qrcode"
                    aria-hidden="true"
                  ></i>{{ r.order_id }}</td>
                <td>{{ r.theOrderID }}</td>
                <td>
                  <span v-if="r.is_ship_only == 1" class="ship-only-label">Ship Only</span>
                </td>
                <td>{{ r.customer_id_fk }}</td>
                                <td class="ws-nowrap">
                                    <i v-if="r.fcm_token" class="material-icons customer-device-icon">smartphone</i>
                  <i v-else class="material-icons customer-device-icon">language</i>
                  <img v-if="r.profile_image" :src="`${$_image_path()}${r.profile_image}`" class="customer-profile-image" />
                  <span v-if="r.full_name && r.full_name.trim().split(/\s+/).length > 3" style="word-break: break-word; white-space: pre-line;">
                    {{ r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n') }}
                  </span>
                  <span v-else>
                    {{ r.full_name }}
                  </span>
                  <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                </td>
                <td class="customer-note-color"> {{ r.customer_note }} </td>
                <td>
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                      (r.product_url.length > 10 ? '...' : '')
                  }}</a>
                </td>
                <td>{{
                  r.product_name.substr(0, 35) +
                    (r.product_name.length > 35 ? '...' : '')
                }}</td>
                <td>{{ r.quantity }}</td>
                <td>{{ r.country }}</td>
                <td>{{ r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : '' }}</td>
                <td>{{ r.purchase_note }}</td>
                <td>{{ r.note }}</td>
                <td
                  style="min-width: 130px"
                  class="hover-container"
                >
                  <view-order-dates :orderData="r" />
                </td>
                <td>{{ r.bank_name }}</td>
                <td
                  v-if="$_has_perm('view_order_detail')"
                  style="padding-left:10px; padding-right:5px"
                >
                  <a
                    style="color:#01579B"
                    tooltip="View Details"
                    @click="initDetail('modal_showApp', r.order_id)"
                  >
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                </td>
                <td
                  v-if="$_has_perm('send_to_pending_shipment')"
                  style="padding-left:0px; padding-right:10px"
                >
                  <a
                    style="color:#4FC3F7"
                    tooltip="Pending Shipment this order"
                    @click="pendingShipmentOrder(r.order_id)"
                  >
                    <span class="pending-boat-icon">
                      <i class="material-icons boat-base">directions_boat</i>
                      <i class="material-icons boat-badge">schedule</i>
                    </span>
                  </a>
                </td>
                <td
                  v-if="$_has_perm('return_warehouse_delivered_order_to_purchased_order')"
                  style="padding-left:0px; padding-right:10px"
                >
                  <a
                    style="color:#eb8545"
                    tooltip="Return to purchase"
                    @click="returnToPurchase(r.order_id)"
                  >
                    <i class="material-icons">settings_backup_restore</i>
                  </a>
                </td>
                <td
                  v-if="$_has_perm('take_photo')"
                  style="padding-left:0px; padding-right:10px"
                >
                  <a
                    style="color:#666; font-size: 16px"
                    tooltip="Take Photo"
                    @click="openTakePhotoModal(r)"
                  >
                    <i class="fa fa-camera"></i>
                  </a>
                </td>
                <td
                  v-if="$_has_perm('add_order_case')"
                  class="px-2"
                >
                  <a
                    @click="openCreateOrderCaseModal(r)"
                    style="color: #555"
                    tooltip="Create Case"
                  >
                    <i
                      class="fa fa-folder-open"
                      style="font-size: 1.6rem"
                    />
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <mobile-datatable
            :isOrder="true"
            v-if="isMobile"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.order_id"
              >
                <td>
                  <i
                    class="fa fa-qrcode"
                    aria-hidden="true"
                  ></i> {{ r.order_id }} , <br />
                  {{ r.theOrderID }} , <br />
                  {{
                    r.product_name.substr(0, 35) +
                      (r.product_name.length > 35 ? '...' : '')
                  }} , <br />
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                      (r.product_url.length > 10 ? '...' : '')
                  }}</a>
                  <br />
                  <span v-if="r.country == 'USA'">
                    <flag iso="um" />
                  </span>
                  <span v-else-if="r.country == 'Turkey'">
                    <flag iso="tr" />
                  </span>
                  <span v-else-if="r.country == 'China'">
                    <flag iso="cn" />
                  </span>
                  <span v-else-if="r.country == 'German'">
                    <flag iso="de" />
                  </span>
                  <span v-else-if="r.country == 'UK'">
                    <flag iso="gb" />
                  </span>
                  &nbsp; {{ r.country }} ,
                  <br />
                  PurchaseNote: {{ r.purchase_note }}
                  <br />
                  Quantity: {{ r.quantity }}
                </td>
                <td>
                  Customer name: {{ r.full_name }} , <br />
                  <span v-if="r.order_date != null">{{ r.order_date }}</span>
                  <span v-else>{{ r.created_at }}</span> <br />
                  Confirm date: {{ r.confirm_date }} , <br />
                  <a
                    v-if="$_has_perm('view_order_detail')"
                    style="color:#01579B; display: inline-block; padding-right: 3px"
                    tooltip="View Details"
                    @click="initDetail('modal_showApp', r.order_id)"
                  >
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                  <span
                    v-if="$_has_perm('send_to_pending_shipment')"
                    style="padding-left:0px; padding-right:5px; float: left"
                  >
                    <a
                      style="color:#4FC3F7"
                      tooltip="Shipment this order"
                      @click="pendingShipmentOrder(r.order_id)"
                    >
                      <span class="pending-boat-icon">
                        <i class="material-icons boat-base">directions_boat</i>
                        <i class="material-icons boat-badge">schedule</i>
                      </span>
                    </a>
                  </span>
                  <span
                    v-if="$_has_perm('return_warehouse_delivered_order_to_purchased_order')"
                    style="padding-left:0px; padding-right:5px; float: left"
                  >
                    <a
                      style="color:#eb8545"
                      tooltip="Return to purchase"
                      @click="returnToPurchase(r.order_id)"
                    >
                      <i class="material-icons">settings_backup_restore</i>
                    </a>
                  </span>
                  <span
                    v-if="$_has_perm('take_photo')"
                    style="padding-left:0px; padding-right:10px; float-left"
                  >
                    <a
                      style="color:#666; font-size: 16px"
                      tooltip="Take Photo"
                      @click="openTakePhotoModal(r)"
                    >
                      <i class="fa fa-camera"></i>
                    </a>
                  </span>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  colspan="2"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </mobile-datatable>

          <view-order-details
            :detialData="detialData"
            :closeModal="closeModal"
          ></view-order-details>

          <send-to-int-shipment
            :closeSendToIntShipmentModal="closeSendToIntShipmentModal"
            :sendToIntShipmentModal="sendToIntShipmentModal"
            :sendToIntShipmentData="sendToIntShipmentData"
            :sendToIntShipment="sendToIntShipment"
          >
          </send-to-int-shipment>

          <take-photo
            :takePhotoModal="takePhotoModal"
            :orderData="orderData"
            @close="takePhotoModal = false"
          />

          <add-new-order
            :addNewOrderModal="addNewOrderModal"
            :warehouses="warehouses"
            :closeAddNewOrderModal="closeAddNewOrderModal"
            :checkAlert="checkAlert"
            :checkURL="checkURL"
            :makeNewOrder="makeNewOrder"
            :makeOrderData="makeOrderData"
            :customers="customers"
            :loading="loading"
          >
          </add-new-order>

          <add-new-shiponly
            :addNewShiponlyModal="addNewShiponlyModal"
            :warehouses="warehouses"
            :closeAddNewShiponlyModal="closeAddNewShiponlyModal"
            :checkAlert="checkAlert"
            :checkURL="checkURL"
            :makeNewOrder="makeNewOrder"
            :makeOrderData="makeOrderData"
            :customers="customers"
            :loading="loading"
          >
          </add-new-shiponly>

          <create-qr-code
            :openGenerateQrCodeModal="openGenerateQrCodeModal"
            :generateQrCodeModal="generateQrCodeModal"
            :closeGenerateQrCodeModal="closeGenerateQrCodeModal"
            :qrCodeValues="qrCodeValues"
            :generateQrCode="generateQrCode"
            :getResults="getResults"
          ></create-qr-code>

          <add-edit-order-case
            :addEditOrderCaseModal="addEditOrderCaseModal"
            :formData="formData"
            :isUpdate="isUpdate"
            @close="addEditOrderCaseModal = false"
          />

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from './Pagination.vue'
import preDatatableComponent from './preDatatableComponent.vue'
import DatatableVue from './Datatable.vue'
import viewOrderDetails from './viewOrderDetails.vue'
import sendToIntShipment from './sendToIntShipment.vue'
import mobileDatatable from './mobileDatatable'
import axios from 'axios'
import swal from 'sweetalert'
import takePhoto from './takePhoto.vue'
import createQrCode from './createQrCode.vue'
import addNewOrder from './addNewOrder.vue'
import addNewShiponly from './addNewShiponly.vue'
import addEditOrderCase from './orderCase/addEditOrderCase.vue'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-order-details': viewOrderDetails,
    'send-to-int-shipment': sendToIntShipment,
    'mobile-datatable': mobileDatatable,
    'create-qr-code': createQrCode,
    takePhoto,
    'add-new-order': addNewOrder,
    'add-new-shiponly': addNewShiponly,
    addEditOrderCase
  },
  mounted() {
    this.perPageFix()
    this.getCustomer()
    this.getWarehouses()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      { label: '', name: '', text: 'Check box', value: '1' },
      {
        label: 'User',
        text: 'User',
        value: '2',
        sortable: false,
        searchable: false,
        name: 'user'
      },
      {
        label: 'Qr ID',
        text: 'Qr ID',
        value: '3',
        sortable: true,
        searchable: true,
        name: 'order_id'
      },
      {
        label: 'OrderID',
        text: 'OrderID',
        value: '4',
        sortable: true,
        searchable: true,
        name: 'theOrderID'
      },
      {
        label: 'Shiponly',
        text: 'Shiponly',
        value: '5',
        sortable: true,
        searchable: true,
        name: 'is_ship_only',
      },
      {
        label: 'Customer ID',
        text: 'Customer ID',
        value: '6',
        sortable: true,
        searchable: true,
        name: 'customer_id_fk'
      },
      {
        label: 'Customer Name',
        text: 'Customer Name',
        value: '7',
        sortable: true,
        searchable: true,
        name: 'full_name'
      },
      {
        label: 'Customer Note',
        text: 'Customer Note',
        value: '8',
        sortable: true,
        searchable: true,
        name: 'customer_note'
      },
      {
        label: 'Product URL',
        text: 'Product URL',
        value: '9',
        sortable: true,
        searchable: true,
        name: 'product_url'
      },
      {
        label: 'Product Name',
        text: 'Product Name',
        value: '10',
        sortable: true,
        searchable: true,
        name: 'product_name'
      },
      {
        label: 'Qty',
        text: 'Qty',
        value: '11',
        sortable: true,
        searchable: true,
        name: 'quantity'
      },
      {
        label: 'Warehouse',
        text: 'Warehouse',
        value: '12',
        sortable: true,
        searchable: true,
        name: 'country'
      },
      {
        label: 'Type',
        text: 'Type',
        value: '13',
        sortable: true,
        searchable: true,
        name: 'transportation_type_obj',
      },
      {
        label: 'Purchase Note',
        text: 'Purchase Note',
        value: '14',
        sortable: true,
        searchable: true,
        name: 'purchase_note'
      },
      {
        label: 'Order Note',
        text: 'Order Note',
        value: '15',
        sortable: true,
        searchable: true,
        name: 'note'
      },
      {
        label: 'Date',
        text: 'Date',
        value: '16',
        sortable: true,
        searchable: true,
        name: 'warehouse_deliver_date'
      },
      {
        label: 'Bank',
        text: 'Bank',
        value: '17',
        sortable: true,
        searchable: true,
        name: 'bank_name',
      },
    ]
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })

    return {
      isMobile: false,
      loading: false,
      url: 'api/warehouse_delivered_order',
      intPendingShipmentUrl: 'api/pending_shipmenting',
      // intShipmentUrl: 'api/int_shipmenting',
      initMultiplePendingShipmentUrl: 'api/pending_shipmenting_multiple_order',
      // initMultipleShipmentUrl: 'api/pending_shipmenting_multiple_order',
      intPendingShipmentByQrCodeUrl: 'api/pending_shipmenting_by_qrcode',
      // intShipmentByQrCodeUrl: 'api/int_shipmenting_by_qrcode',
      orderDetailUrl: 'api/show_order_detail',
      returnToPurchaseUrl: 'api/orders/',
      sendToIntShipmentModal: false,
      generateQrCodeModal: false,
      qrCodeValues: [],
      alertValue: false,
      checkAlert: false,
      filterMade: false,
      totalResult: 0,
      btnsave: true,
      queryParameter: true,
      orderData: {},
      takePhotoModal: false,
      addNewOrderModal: false,
      addNewShiponlyModal: false,
      formData: {},
      isUpdate: false,
      addEditOrderCaseModal: false,
      warehouses: [],
      customers: [],
      checkURL: false,
      makeOrderData: {
        customer_id_fk: '',
        warehouse_id_fk: '',
        transportation_type: null,
        product_name: '',
        product_url: '',
        quantity: '',
        delivery_type: '',
        item_weight: '',
        volume: '',
        track_number: '',
        coupon: '',
        size: '',
        type: '',
        color: '',
        note: '',
        is_from_warehouse: 1,
        is_ship_only: 1
      },
      sendToIntShipmentData: {
        order_id: ''
      },
      detialData: {},
      prevSearchQuery: '',
      apiResults: [],
      orderID: [],
      detailResults: [],
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    checkAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },

    unCheckAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },

    openCreateOrderCaseModal(order) {
      this.formData = {
        order_id_fk: order.order_id,
        order: order,
        note: null
      }
      this.isUpdate = false
      this.addEditOrderCaseModal = true
    },

    getWarehouses() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let result = response.data.data
          result.forEach((r) => {
            this.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types })
          })
        })
    },

    getCustomer() {
      let token = localStorage.getItem('access_token')

      axios
        .get('api/get-customer-to-select', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          response.data.data.forEach((c) => {
            this.customers.push({
              text: c.user_id + ' - ' + c.full_name + ' - Tel: ' + c.phone_number,
              value: c.user_id
            })
          })
        })
    },

    getItemType() {
      let token = localStorage.getItem('access_token')

      axios
        .get('api/get-item-type', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          response.data.data.forEach((c) => {
            this.itemTypes.push({
              text: c.type_name,
              value: c.type_name,
              shippingPrice: c.type_int_shipping_price
            })
          })
        })
    },

    clearNewOrderData() {
      this.makeOrderData.warehouse_id_fk = null
      this.makeOrderData.transportation_type = null
      this.makeOrderData.product_name = ''
      this.makeOrderData.product_url = ''
      this.makeOrderData.quantity = ''
      this.makeOrderData.item_weight = ''
      this.makeOrderData.volume = ''
      this.makeOrderData.track_number = ''
      this.makeOrderData.note = ''
      this.makeOrderData.coupon = ''
      this.makeOrderData.size = ''
      this.makeOrderData.type = ''
      this.makeOrderData.color = ''
      this.makeOrderData.c_o_d = ''
      this.makeOrderData.is_from_warehouse = 1
      this.makeOrderData.is_ship_only = 1
      this.makeOrderData.customer_id_fk = null
      this.checkAlert = false
      this.checkURL = false
      this.loading = false
    },

    openAddNewOrderModal() {
      this.makeOrderData.warehouse_id_fk = this.warehouses[0].value
      this.addNewOrderModal = true
    },

    openAddNewShiponlyModal() {
      this.addNewShiponlyModal = true
    },

    closeAddNewOrderModal() {
      this.addNewOrderModal = false
      this.clearNewOrderData()
    },

    closeAddNewShiponlyModal() {
      this.addNewShiponlyModal = false
      this.clearNewOrderData()
    },

    makeNewOrder() {
      this.loading = true
      let token = localStorage.getItem('access_token')

      this.makeOrderData.delivery_type = 'office delivery'
      this.makeOrderData.status = 'warehouse_delivered_order'

      axios.post('api/orders', this.makeOrderData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then((res) => {
        this.loading = false
        this.checkURL = false
        this.checkAlert = true
        setTimeout(() => {
          this.closeAddNewShiponlyModal()
          this.openTakePhotoModal(res.data.data)
        }, 500)
        this.getResults()
      }).catch((error) => {
        this.loading = false
        this.checkAlert = false
        if (error.response.data.message.product_url) {
          this.checkURL = true
        } else {
          this.checkURL = false
          swal('Error', `${error.response.data.message}`, 'error')
        }
      })
    },

    openGenerateQrCodeModal() {
      if (this.qrCodeValues.length < 1) {
        swal({
          text: 'Please at least select one order!',
          icon: 'warning',
          dangerMode: true
        })
      } else {
        this.generateQrCodeModal = true
      }
    },

    closeGenerateQrCodeModal() {
      this.generateQrCodeModal = false
      this.qrCodeValues = []
    },

    generateQrCode() {
      this.closeGenerateQrCodeModal()
    },

    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    openTakePhotoModal(order) {
      this.orderData = order
      this.takePhotoModal = true
    },

    sendToExport() {
      let arr = ''

      for (let i = 0; i < this.orderID.length; i++) {
        if (i < this.orderID.length - 1) {
          arr = arr.concat('arr[]=' + this.orderID[i] + '&')
        } else {
          arr = arr.concat('arr[]=' + this.orderID[i])
        }
      }

      let hostName = window.location.hostname
      let protocol = window.location.protocol + '//'
      let fullHostName = protocol + hostName
      window.location.replace(fullHostName + '/api/warehouse-export?' + arr)
    },

    getOrderID(orders) {
      this.orderID = []
      for (let i = 0; i < orders.length; i++) {
        this.orderID[i] = orders[i].order_id
      }
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          if (data.data.length > 0) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (data.data.length > 0) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          this.getOrderID(this.apiResults)
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch(errors => { })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    sendAllToIntShipment() {
      const ordersId = this.qrCodeValues.map(e => e[0])

      if (ordersId.length === 0) {
        return swal('Error', 'Please select order', 'error')
      }

      swal({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(confirmed => {
        if (confirmed) {
          let token = localStorage.getItem('access_token')
          axios
            .put(this.initMultiplePendingShipmentUrl, { orders_id: ordersId }, {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(() => {
              this.getResults()
              swal({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
            .catch(error => {
              if (error.response) {
                swal('Error', `${error.response.data.message}`, 'error')
              }
            })
        }
      })
    },

    openSendToIntShipmentModal() {
      this.sendToIntShipmentModal = true
    },

    closeSendToIntShipmentModal() {
      this.sendToIntShipmentModal = false
      this.sendToIntShipmentData.order_id = ''
      this.$validator.reset()
    },

    sendToIntShipment() {
      let token = localStorage.getItem('access_token')

      axios
        .put(this.intPendingShipmentByQrCodeUrl + '/' + this.sendToIntShipmentData.order_id, '', {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => {
          this.sendToIntShipmentData.order_id = ''
          this.getResults()
          swal({
            title: 'Done',
            text: '',
            icon: 'success',
            timer: 500,
            buttons: false
          })
        })
        .catch(error => {
          swal('Error', `${error.response.data.message}`, 'error')
        })
    },

    pendingShipmentOrder(id) {
      swal({
        title: 'Are you sure?',
        text: 'Once Pending shipmented, you will not be able to return this order to this step!',
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .put(this.intPendingShipmentUrl + '/' + id, '', {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(response => {
              this.getResults()
              swal({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 500,
                buttons: false
              })
            })
            .catch(error => {
              if (error.response) {
                swal('Error', `${error.response.data.message}`, 'error')
              }
            })
        }
      })
    },

    returnToPurchase(id) {
      swal({
        title: 'Are you sure?',
        text: 'You really want to return this order to Purchased section?',
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .put(this.returnToPurchaseUrl + id + '/return_to_purchase', '', {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(response => {
              this.getResults()
              swal({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
            .catch(error => {
              if (error.response) {
                swal('Error', `${error.response.data.message}`, 'error')
              }
            })
        }
      })
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          this.detailResults = data.data

          this.detialData = this.detailResults[0]
        })
      this.modal(modal)
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>

.ship-only-label {
  display: inline-block;
  padding: 2px 8px;
  border: 2px solid #333;
  border-radius: 5px;
  font-weight: bold;
  font-size: 0.9em;
  color:green;
  border-color: green ;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.icon-enlarge,
.icon-pencil {
  color: navy;
}

.icon-bin2 {
  color: red;
}

.icon-calendar {
  color: green;
}

.btn {
  transition: all 0.5s;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  /* overflow: hidden; */
  /* overflow-y: hidden; */
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td
{
  padding: 0 5px !important;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}
.pending-boat-icon {
  position: relative;
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
}
.pending-boat-icon .boat-base {
  font-size: 24px;
  line-height: 24px;
}
.pending-boat-icon .boat-badge {
  position: absolute;
  bottom: -4px;
  right: -6px;
  font-size: 14px;
  background: #fff;
  color: #ff9800; /* pending color */
  border-radius: 50%;
  padding: 2px;
  box-shadow: 0 0 0 1px #ddd;
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/warehouseDeliveredOrder.vue